module.exports = __webpack_public_path__ + "static/media/Plant Shop.04db317a.png";